// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyDgM4BFRO95dXo_SzjDRxF_zS4DFbNK-JY",
    authDomain: "withlove-d08f3.firebaseapp.com",
    projectId: "withlove-d08f3",
    storageBucket: "withlove-d08f3.firebasestorage.app",
    messagingSenderId: "29341239342",
    appId: "1:29341239342:web:5bacec1e1544a3badb77bf"
  };

// Inicializando o Firebase
const app = initializeApp(firebaseConfig);

// Configurando Firestore e Firestorage
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
